import React, { useContext } from "react";
import classNames from "classnames";

// Components
import Link from "../../../../../../Atoms/Link";
import Paragraph from "../../../../../../Atoms/Paragraph";

// Stylesheets
import styles from "./style.module.scss";

// Utils
import {
  ImgixImage,
  ImgixPicture,
  ImgixSource,
} from "../../../../../../Utils/ImgixImage";
import { TrackingContext } from "../../../../../../Utils/TrackingWrapper";

export const MobileSubNavigation = ({ menu }) => {
  const {
    trackingActions: { trackNavigation },
  } = useContext(TrackingContext);

  const onClickLink = (linkText) => {
    trackNavigation({
      clickURL: document.location.pathname,
      clickText: linkText,
      location: "main nav",
    });
  };

  return (
    <div className={styles.mobileSubNavigation}>
      <ul className={styles.listReset}>
        {menu.map((menuItem, index) => (
          <li key={index}>
            <Link
              className={classNames(
                styles.linkReset,
                styles.mobileSubNavigation_menuItem
              )}
              to={menuItem.url}
              onClick={() => {
                onClickLink(menuItem.title);
              }}
            >
              {menuItem.image ? (
                <ImgixPicture
                  fallback={
                    <ImgixImage
                      src={menuItem.image.src}
                      alt={menuItem.image.alt}
                    />
                  }
                >
                  <ImgixSource src={menuItem.image.src} width={1000} />
                </ImgixPicture>
              ) : (
                ""
              )}
              {menuItem.imageBadges ? (
                <div className={styles.mobileSubNavigation_badges}>
                  {menuItem.imageBadges.map((badge, index) => (
                    <div
                      key={index}
                      className={classNames(
                        styles.mobileSubNavigation_badge,
                        badge.backgroundColor === "lightNavy"
                          ? styles.mobileSubNavigation_badgeLightNavy
                          : ""
                      )}
                    >
                      <Paragraph className="caption_secondary">
                        {badge.title}
                      </Paragraph>
                    </div>
                  ))}
                </div>
              ) : null}
              <Paragraph className="body_primary">{menuItem.title}</Paragraph>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileSubNavigation;
